export enum ActionTypes {
  GET_FIRST_CONTACT_FOR_ACCOUNT = '[GET_FIRST_CONTACT_FOR_ACCOUNT] Get first contact for account',
  GET_FIRST_CONTACT_FOR_ACCOUNT_SUCCESS = '[GET_FIRST_CONTACT_FOR_ACCOUNT] Get first contact for account success',
  GET_FIRST_CONTACT_FOR_ACCOUNT_FAILURE = '[GET_FIRST_CONTACT_FOR_ACCOUNT] Get first contact for account failure',
}
